import { checkPhone, checkEmail } from '@/api'
import { reg } from '@/utils/function'
/**
 * el-form 自定义验证方法
 * @param {function} validate
 * @param {function} fn
 */
export const validateFn = (validate, fn) => {
  if (!validate || typeof validate != 'function') return
  return function(rule, value, callback) {
    if (validate(value)) {
      if (fn && typeof validate == 'function') {
        fn(rule, value, callback)
      } else {
        callback()
      }
    } else {
      return callback(new Error(rule.message))
    }
  }
}

/**
 * @param {array} list
 * @returns {Boolean}
 */
export function validImagesLength(list) {
  let imgs = list.filter(item => {
    return item != ''
  })
  return imgs.length === 0 ? false : true
}

export function validateMobile(rule, value, callback) {
  checkPhone({ mobile: value }).then(res => {
    if (res.data.data.repeat) {
      callback(new Error(rule.message))
    } else {
      callback()
    }
  })
}

export function validateIDCard(rule, value, callback) {
  if (reg.idcard.exec(value)) {
    callback()
  } else {
    callback(new Error(rule.message))
  }
}


export function validateEmail2(rule, value, callback) {
  if (reg.email.exec(value)) {
    callback()
  } else {
    callback(new Error(rule.message))
  }
}

export function validateEmail(rule, value, callback) {
  if (rule.oldEmail === value) {
    callback()
    return false
  }
  checkEmail({ email: value }).then(res => {
    if (res.data.data.repeat) {
      callback(new Error(rule.message))
    } else {
      callback()
    }
  })
}

export function validateEmailorMobile(rule, value, callback) {
  if (reg.chinesePhone.exec(value) || reg.email.exec(value)) {
    callback()
  } else {
    callback(new Error(rule.message))
  }
}

export function validateEmail3(value) {
  if (reg.email.exec(value)) {
    return true
  }
  return false
}

export function validateMobile3(value) {
  if (reg.chinesePhone.exec(value)) {
    return true
  }
  return false
}
